import { useState, useEffect } from 'react';

function getDevice() {
  if (typeof window === 'undefined') return 'desktop';
  if (window.matchMedia('(max-width:599px)').matches) return 'mobile';
  if (window.matchMedia('(min-width:600px) and (max-width:899px)').matches) return 'tablet';
  return 'desktop';
}

export default function useDevice() {
  const [device, setDevice] = useState(getDevice());

  useEffect(() => {
    const mMobile = window.matchMedia('(max-width:599px)');
    const mTablet = window.matchMedia('(min-width:600px) and (max-width:899px)');
    const mDesktop = window.matchMedia('(min-width:900px)');
    const handler = () => setDevice(getDevice());

    if (mMobile.addEventListener) {
      mMobile.addEventListener('change', handler);
      mTablet.addEventListener('change', handler);
      mDesktop.addEventListener('change', handler);
    } else {
      mMobile.addListener(handler);
      mTablet.addListener(handler);
      mDesktop.addListener(handler);
    }
    window.addEventListener('orientationchange', handler);

    return () => {
      if (mMobile.removeEventListener) {
        mMobile.removeEventListener('change', handler);
        mTablet.removeEventListener('change', handler);
        mDesktop.removeEventListener('change', handler);
      } else {
        mMobile.removeListener(handler);
        mTablet.removeListener(handler);
        mDesktop.removeListener(handler);
      }
      window.removeEventListener('orientationchange', handler);
    };
  }, []);

  return device;
}
